import { render, staticRenderFns } from "./OcrFileSelect.vue?vue&type=template&id=f59b5230&scoped=true"
import script from "./OcrFileSelect.vue?vue&type=script&lang=js"
export * from "./OcrFileSelect.vue?vue&type=script&lang=js"
import style0 from "./OcrFileSelect.vue?vue&type=style&index=0&id=f59b5230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59b5230",
  null
  
)

export default component.exports